<script lang="ts">
	interface Props {
		member: 'robert' | 'mahder' | 'mitanshu';
		size?: number;
	}
	
	let { member, size = 200 }: Props = $props();
	
	// Map team members to their avatar images
	const avatars = {
		mahder: '/images/team/mahder.png',
		mitanshu: '/images/team/mitanshu.png', 
		robert: '/images/team/robert.png'
	};
	
	const names = {
		mahder: 'Mahder',
		mitanshu: 'Mitanshu',
		robert: 'Robert'
	};
</script>

<div class="avatar-container" style="width: {size}px; height: {size}px;">
	<img
		src={avatars[member]}
		alt="{names[member]} avatar"
		class="avatar-image"
		width={size}
		height={size}
		loading="lazy"
	/>
</div>

<style>
	.avatar-container {
		position: relative;
		border-radius: 50%;
		overflow: hidden;
		background: var(--brand-gradient);
		padding: 3px;
		box-shadow: var(--shadow-lg);
		transition: transform 0.3s ease;
	}
	
	.avatar-container:hover {
		transform: scale(1.05);
	}
	
	.avatar-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 50%;
		background: var(--bg-primary);
	}
	
	@keyframes float {
		0%, 100% { transform: translateY(0); }
		50% { transform: translateY(-5px); }
	}
	
	.avatar-container:hover {
		animation: float 3s ease-in-out infinite;
	}
</style>